import styles from './ComingSoon.module.css';

export default function ComingSoon() {
    return (
        <div className={styles.comingSoonContainer}>
            <div className={styles.comingSoonContent}>
                <h1>Coming soon.</h1>
                <p>Add to bookmarks and come back later!</p>
            </div>
        </div>
    )
}